import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { Tab } from '@app/shared/components/tabs/tab.interface';
import { HeaderService } from '@app/shared/services/header.service';
import { UserService } from '@app/shared/services/user/user.service';
import { User } from '@app/shared/models/user.interface';
import { Building } from '@app/shared/models/building.interface';
import { driverMetricsTabs } from '@app/driver-metrics/layout/driver-metrics-tabs';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NavigationService } from '@services/navigation/navigation.service';
import { TabsComponent } from '@components/tabs/tabs.component';

@Component({
  selector: 'app-driver-metrics-layout',
  templateUrl: './driver-metrics.component.html',
  imports: [TabsComponent, RouterOutlet],
  styleUrls: ['./driver-metrics.component.scss']
})
export class DriverMetricsLayoutComponent implements OnInit, OnDestroy {
  public tabs$: Observable<Tab[]>;

  constructor(
    private readonly header: HeaderService,
    private readonly userService: UserService,
    private readonly route: ActivatedRoute,
    private readonly navigationService: NavigationService
  ) {}

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.header.showBuildingsMenu();
    this.header.showSiteMenu();
    this.header.showUserMenu();
    this.header.showSessionMenu();

    this.tabs$ = this.route.params.pipe(
      switchMap((params) =>
        combineLatest([this.userService.getCurrentUser(), this.userService.getBuilding(params.buildingId)])
      ),
      map(([user, building]) => {
        this.navigationService.initNavigation(window.location.href, building);
        return this.createMenu(user, building);
      })
    );
  }

  private createMenu(user: User, building: Building): Tab[] {
    const tabs = [];
    driverMetricsTabs.forEach((tab) => {
      let resolvedPath = '';
      if (tab.isAuthorized(user, building)) {
        resolvedPath = tab.path.replace(/\{buildingId}/i, String(building.id));
        if (!resolvedPath.includes('undefined')) {
          tabs.push({
            ...tab,
            path: resolvedPath
          });
        }
      }
    });
    return tabs;
  }
}
